<template>
	<v-text-field
		v-if="regex !== ''"
		v-bind="$attrs"
		id="campoMascaraRegex"
		v-model="internalValue"
		v-input-mask="{ regex: regex }"
		class="v-text-field__arp-margin"
		v-validate="validate"
		validate-on-blur
		:error-messages="errors.collect($attrs.name)"
		v-on="$listeners"
	></v-text-field>
	<v-text-field
		v-else
		v-bind="$attrs"
		id="campoMascaraRegex"
		v-model="internalValue"
		class="v-text-field__arp-margin"
		v-validate="validate"
		validate-on-blur
		:error-messages="errors.collect($attrs.name)"
		v-on="$listeners"
	></v-text-field>
</template>

<script>
export default {
	name: 'campo-mascara-regex',
	props: {
		regex: {
			type: String,
			default: null,
		},
		validate: {
			type: Object,
			default() {
				return {}
			},
		},
		value: {
			type: String,
			default: null,
		},
	},
	computed: {
		internalValue: {
			get() {
				return this.value
			},
			set(newValue) {
				this.$emit('input', newValue)
			},
		},
	},
}
</script>
